module.exports = __webpack_public_path__ + "img/salesChart.3cddc263.png";